import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'legrandav-textinput-default-m',
  styleUrl: 'legrandav-textinput-default-m.css',
  shadow: true,
})
export class LegrandavTextinputDefaultM {
  @Prop() label: string;
  @Prop() placeHolder: string;
  @Prop() showErrorState: boolean = false;
  @Prop() errorMessage: string;

  render() {
    return (
      <Host>
        <div class={this.showErrorState ? 'legrandav-textinput-default-m-wrapper-Error-State' : 'legrandav-textinput-default-m-wrapper'}>
          <label htmlFor={this.label}>{this.label}</label>
          <input id={this.label} type="text" placeholder={this.placeHolder} />
          {this.showErrorState ? <span class="error-message">{this.errorMessage}</span> : ''}
        </div>
      </Host>
    );
  }
}
